<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { cloneDeep } from 'lodash';

export default {
  mixins: [fandomBasicMixin],
  data: function () {
    return {
      gridContent: null,
      resultContentName: null,
    };
  },
  mounted() {
    Fandom.deleteCookie('evaluation_tool_result_url');
    Fandom.post({
      url: '/api/v5/evaluation_tool/results',
      data: { content_cache_id: this.getContent(this.content.evaluation_tool_content).id },
      success: (data) => {
        Vue.set(this, 'resultContentName', data.result_page_model.main_content_name);
        Fandom.getContentsCallback(data.result_page_model.main_content_name, data.result_page_model);
        Fandom.getContentsCallback(data.grid_page_model.main_content_name, data.grid_page_model, (data) => {
          Vue.set(this, 'gridContent', cloneDeep(this.getContent(data.main_content_name)));
          Vue.set(this.gridContent, 'children', this.gridContent.children.slice(0,4));
          Vue.set(this.gridContent, 'has_more_children', this.getContent(data.main_content_name).children.length > 4);
        })
      },
      error: (err) => { console.log(err); }
    })
  },
  methods: {
    alternativeAppendContents() {
      const originalContent = this.getContent(this.gridContent.name);
      const newChildrenNumber = this.gridContent.children.length < 8 ? 8 : 12;
      Vue.set(this.gridContent, 'children', originalContent.children.slice(0,newChildrenNumber));
      Vue.set(this.gridContent, 'has_more_children', originalContent.children.length > newChildrenNumber);
    }
  },
  computed: { }
};
</script>

<template>
  <div 
    page-evaluation-tool-results-component
    :class="contentType" 
    v-easyadmin="easyadminId" 
    v-if="isContentVisibleToUser() && gridContent" 
  >
    <breadcrumb :breadcrumb="pageModel.breadcrumb"></breadcrumb>
    <component
      v-if="resultContentName && getContent(resultContentName)"
      :is="getContent(resultContentName).layout"
      :content="getContent(resultContentName)"
      :opt-container-content="getContent(resultContentName)"
    ></component>
    <grid-isotope
      v-if="gridContent"
      :content="gridContent"
      :opt-container-content="gridContent"
      :alternative-append-contents="alternativeAppendContents"
    ></grid-isotope>
    <component
      :is="stripe.layout"
      :content="stripe"
      :key="stripe.$id"
      v-for="stripe in content.stripes"
      :opt-container-content="containerContent"
    ></component>
  </div>
</template>

<style lang="scss">
</style>
